import { Editor, Path, Range, Text } from 'slate';

export function getWordAndCharacterCount(editor: Editor, range?: Range) {
  let text = '';
  let prevPath: Path | null = null;
  let characters = 0;

  range = !range || !Range.isRange(range) ? Editor.range(editor, []) : range;
  const [start, end] = Range.edges(range);

  for (const [node, path] of Editor.nodes(editor, {
    at: range,
    match: Text.isText,
  })) {
    let t = node.text;

    if (Path.equals(path, end.path)) {
      t = t.slice(0, end.offset);
    }

    if (Path.equals(path, start.path)) {
      t = t.slice(start.offset);
    }

    if (prevPath && !Path.equals(prevPath.slice(0, -1), path.slice(0, -1))) {
      text += ' ';
    }
    text += t;
    characters += t.length;
    prevPath = path;
  }

  return { words: text.split(/\s+/).filter(Boolean).length, characters };
}
